import React, { Fragment } from 'react';
import SSOFormFooter from '../common/utility/SSOFormFooter';
import { formConstants } from './constants/form-constants';
import { formMessageConstants } from './constants/form-message-constants';
import { isEmpty, deepCopyObject } from './obj-utils';
import AddAddressForm from '../forms/user-addresses/AddAddressForm';
import FormAddressDisplayField from '../forms/user-addresses/FormAddressDisplayField';
import UpdateAddressForm from '../forms/user-addresses/UpdateAddressForm';

export const addressesFormConstants = {
    /* eslint-disable */
    addressDisplayForm: ({ accountFormData, accountData, callbackFunctions }) => {
        return displayUserAddresses(accountFormData, accountData, callbackFunctions);
    },
    addressAddForm: ({ accountFormData, callbackFunctions }) => {
        const { handleAddNewAddress, handleShowDisplayAddressForm } = callbackFunctions;
        return <AddAddressForm
            formData={accountFormData}
            onAddAddressClick={handleAddNewAddress}
            onCloseAddAddressFormClick={handleShowDisplayAddressForm}></AddAddressForm>
    },
    addressUpdateForm: ({ accountFormData, callbackFunctions, addressForUpdate }) => {
        const { handleUpdateAddress, handleShowDisplayAddressForm } = callbackFunctions;
        const formData = getUpdateAddressFormData(accountFormData, addressForUpdate);
        return <UpdateAddressForm
            formData={formData}
            onUpdateAddressClick={handleUpdateAddress}
            onCloseUpdateAddressFormClick={handleShowDisplayAddressForm}></UpdateAddressForm>
    },
    /* eslint-enable */
};


const displayUserAddresses = (accountFormData, accountData, callbackFunctions) => {
    const { addresses } = accountData;
    const { handleShowAddAddressForm } = callbackFunctions;

    if (isEmpty(addresses)) {
        return (<Fragment>
            <div className='no-files'>
                <p className='info'>{accountFormData[formConstants.noAddressFoundText] || formMessageConstants.noAddressesFound}</p>
            </div>
            <SSOFormFooter
                onSubmit={handleShowAddAddressForm}
                footerButtonText={formMessageConstants.addNewAddress}>
            </SSOFormFooter>
        </Fragment>);
    }

    return displayAddresses(accountFormData, accountData, callbackFunctions);
};

const displayAddresses = (accountFormData, accountData, callbackFunctions) => {
    const { addresses } = accountData;
    const {
        handleShowAddAddressForm,
        handleShowUpdateAddressForm,
        handleUpdateAddress,
        handleRemoveAddress
    } = callbackFunctions;
    const { mainAddress, shippingAddress, billingAddress } = accountFormData;
    const formData = { mainAddress, shippingAddress, billingAddress };
    const addressesDisplayForm = addresses
        .sort((a, b) => {
            if (a.main === b.main) {
                return 0;
            }

            return a.main ? -1 : 1;
        })
        .map((address, index) => {
            const isLast = index === addresses.length - 1;

            return <div key={index} className="addresses">
                <FormAddressDisplayField
                    formData={formData}
                    address={address}
                    isLast={isLast}
                    onEditAddressClick={handleShowUpdateAddressForm}
                    onRemoveAddressClick={handleRemoveAddress}
                    onUpdateAddressClick={handleUpdateAddress}></FormAddressDisplayField>
            </div>;
        });

    return (<Fragment>
        {addressesDisplayForm}
        <SSOFormFooter
            onSubmit={handleShowAddAddressForm}
            footerButtonText={formMessageConstants.addNewAddress}>
        </SSOFormFooter>
    </Fragment>);
};

const getUpdateAddressFormData = (accountFormData, addressForUpdate) => {
    const formData = deepCopyObject(accountFormData);

    formData[formConstants.addressLine1].defaultValue = addressForUpdate[formConstants.addressLine1] || formMessageConstants.emptyString;
    formData[formConstants.addressLine2].defaultValue = addressForUpdate[formConstants.addressLine2] || formMessageConstants.emptyString;
    formData[formConstants.addressLine3].defaultValue = addressForUpdate[formConstants.addressLine3] || formMessageConstants.emptyString;
    formData[formConstants.postcode].defaultValue = addressForUpdate[formConstants.postcode] || formMessageConstants.emptyString;
    formData[formConstants.city].defaultValue = addressForUpdate[formConstants.city] || formMessageConstants.emptyString;

    formData[formConstants.country].defaultValue = addressForUpdate[formConstants.country];
    formData[formConstants.country].countryName = addressForUpdate[formConstants.countryName] || formMessageConstants.emptyString;
    formData[formConstants.county].defaultValue = addressForUpdate[formConstants.county];
    formData[formConstants.state].defaultValue = addressForUpdate[formConstants.state];

    formData[formConstants.mainAddress].defaultValue = addressForUpdate[formConstants.main];
    formData[formConstants.shippingAddress].defaultValue = addressForUpdate[formConstants.shippingAddress];
    formData[formConstants.billingAddress].defaultValue = addressForUpdate[formConstants.billingAddress];

    return formData;
};
